export default {
  stateKey: 'italic',
  order: 4,
  commandKey: 'toggleItalic',
  icon: ['far', 'italic'],
  appearance: {
    menu: true,
    bubble: true,
  },
}
